export const productStatus = {
  1: 'ATIVO',
  2: 'INATIVO',
  3: 'BLOQUEADO',
}
